import { SITE_URL } from '@/constants/site';
import { mainSiteUrl } from '@/mocks/categories';

export default function SuperbuyArticle() {
  const siteUrl = SITE_URL;

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md">
        <div className="w-full px-4 md:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2 no-underline">
              <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950 tracking-tight">
                Kakobuy <span className="text-primary-500">Finds</span>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Open Spreadsheet
            </a>
          </div>
        </div>
      </nav>

      <main className="pt-24 pb-16">
        <article className="max-w-[800px] mx-auto px-4 md:px-8">
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: [
                  { '@type': 'ListItem', position: 1, name: 'Strona główna', item: siteUrl },
                  { '@type': 'ListItem', position: 2, name: 'Superbuy Spreadsheet – Kompletny Przewodnik 2026', item: siteUrl + '/artykul/superbuy-spreadsheet-przewodnik' },
                ],
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Article',
                headline: 'Superbuy Spreadsheet – Kompletny Przewodnik 2026',
                description: 'Dowiedz się wszystkiego o Superbuy Spreadsheet — jak działa, jakie kategorie zawiera, jak wypada w porównaniu z Kakobuy i czy warto z niego korzystać. Pełny przewodnik 2026.',
                datePublished: '2026-07-08',
                dateModified: '2026-07-08',
                author: { '@type': 'Organization', name: 'Kakobuy Finds' },
                publisher: { '@type': 'Organization', name: 'Kakobuy Finds', logo: { '@type': 'ImageObject', url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png' } },
                image: 'https://readdy.ai/api/search-image?query=Modern%20lifestyle%20setup%20with%20smartphone%20displaying%20shopping%20app%20and%20fashion%20items%20scattered%20on%20clean%20wooden%20desk%2C%20minimal%20workspace%20aesthetic%2C%20warm%20cream%20and%20soft%20gray%20tones%2C%20natural%20morning%20window%20light%2C%20premium%20productivity%20photography&width=1200&height=600&seq=superbuy-article-banner-v2&orientation=landscape',
                mainEntityOfPage: { '@type': 'WebPage', '@id': siteUrl + '/artykul/superbuy-spreadsheet-przewodnik' },
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: 'Czy Superbuy Spreadsheet jest lepszy od Kakobuy?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Nie — Kakobuy Spreadsheet oferuje więcej kategorii (14 vs mniej), częstsze aktualizacje i większą bazę produktów. Superbuy jest dobrą alternatywą, ale nie przewyższa Kakobuy pod względem kompleksowości.' },
                  },
                  {
                    '@type': 'Question',
                    name: 'Jakie kategorie zawiera Superbuy Spreadsheet?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Superbuy Spreadsheet obejmuje kategorie takie jak sneakersy, odzież, akcesoria i elektronika. Jest to węższy zakres niż 14 kategorii oferowanych przez Kakobuy Spreadsheet.' },
                  },
                  {
                    '@type': 'Question',
                    name: 'Czy warto korzystać z Superbuy Spreadsheet?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Tak, Superbuy Spreadsheet jest wartościowym narzędziem, szczególnie jako uzupełnienie Kakobuy. Jeśli szukasz dodatkowych źródeł produktów — warto dać mu szansę.' },
                  },
                ],
              }),
            }}
          />

          <nav className="mb-8" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-foreground-800 transition-colors">Strona główna</a></li>
              <li><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-foreground-800 font-medium">Superbuy Spreadsheet – Przewodnik</li>
            </ol>
          </nav>

          <header className="mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wider uppercase mb-5">
              Przewodnik 2026
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              Superbuy Spreadsheet – Kompletny Przewodnik 2026
            </h1>
            <p className="text-base md:text-lg text-foreground-500 leading-relaxed mb-6">
              Wszystko, co musisz wiedzieć o <strong>Superbuy Spreadsheet</strong> — jednej z rosnących alternatyw dla arkuszy produktowych. Sprawdź, jak działa, co oferuje i czy warto z niej korzystać.
            </p>
            <div className="flex items-center gap-3 text-sm text-foreground-400">
              <span>Aktualizacja: Lipiec 2026</span>
              <span>·</span>
              <span>Czas czytania: 8 minut</span>
            </div>
          </header>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Czym jest Superbuy Spreadsheet?
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                <strong>Superbuy Spreadsheet</strong> to uporządkowana baza danych produktowych, która w ostatnim czasie zyskuje na popularności wśród społeczności zakupowej. Jest to arkusz zawierający wyselekcjonowane produkty z różnych kategorii, zorganizowane w przejrzysty sposób z bezpośrednimi linkami do stron zakupowych. Choć nie jest tak rozbudowany jak <a href="/" className="text-primary-600 hover:text-primary-700 underline">Kakobuy Spreadsheet</a>, oferuje solidną bazę produktów dla osób poszukujących sprawdzonych okazji.
              </p>
              <p className="text-base text-foreground-700 leading-relaxed">
                <strong>Superbuy Spreadsheet</strong> koncentruje się głównie na kategoriach takich jak sneakersy, odzież markowa, akcesoria i elektronika. Jest to dobre narzędzie uzupełniające dla osób, które już korzystają z <a href="/" className="text-primary-600 hover:text-primary-700 underline">Kakobuy Spreadsheet</a> i chcą poszerzyć swoje źródła produktów.
              </p>
            </section>

            <div className="my-10 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20lifestyle%20setup%20with%20smartphone%20displaying%20shopping%20app%20and%20fashion%20items%20scattered%20on%20clean%20wooden%20desk%2C%20minimal%20workspace%20aesthetic%2C%20warm%20cream%20and%20soft%20gray%20tones%2C%20natural%20morning%20window%20light%2C%20premium%20productivity%20photography&width=1200&height=600&seq=superbuy-article-banner-v2&orientation=landscape"
                alt="Superbuy Spreadsheet przewodnik"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Główne funkcje Superbuy Spreadsheet
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-6">
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-folder-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Organizacja kategorii</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">Produkty są posegregowane według typu — sneakersy, odzież, akcesoria, elektronika. Każda kategoria jest przejrzyście oznaczona.</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-link text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Bezpośrednie linki</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">Każdy produkt w arkuszu posiada aktywny link, który przenosi bezpośrednio do strony zakupu.</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-calendar-check-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Regularne aktualizacje</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">Baza jest odświeżana regularnie, choć nie tak często jak Kakobuy Spreadsheet — nowe produkty pojawiają się co kilka dni.</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-money-dollar-circle-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Darmowy dostęp</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">Podobnie jak Kakobuy, Superbuy Spreadsheet jest dostępny całkowicie za darmo, bez ukrytych opłat.</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Superbuy vs Kakobuy – szybkie porównanie
              </h2>
              <div className="overflow-x-auto rounded-lg border border-background-200/70">
                <table className="w-full text-sm">
                  <thead className="bg-background-100">
                    <tr>
                      <th className="text-left px-4 py-3 font-semibold text-foreground-800">Aspekt</th>
                      <th className="text-left px-4 py-3 font-semibold text-primary-600">Kakobuy</th>
                      <th className="text-left px-4 py-3 font-semibold text-secondary-600">Superbuy</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-background-200/70">
                    <tr><td className="px-4 py-3 text-foreground-700">Liczba kategorii</td><td className="px-4 py-3 text-foreground-900 font-medium">14</td><td className="px-4 py-3 text-foreground-700">~8</td></tr>
                    <tr className="bg-background-50/50"><td className="px-4 py-3 text-foreground-700">Aktualizacje</td><td className="px-4 py-3 text-foreground-900 font-medium">Codziennie</td><td className="px-4 py-3 text-foreground-700">Co kilka dni</td></tr>
                    <tr><td className="px-4 py-3 text-foreground-700">Język</td><td className="px-4 py-3 text-foreground-900 font-medium">Polski / EN</td><td className="px-4 py-3 text-foreground-700">Angielski</td></tr>
                    <tr className="bg-background-50/50"><td className="px-4 py-3 text-foreground-700">Baza produktów</td><td className="px-4 py-3 text-foreground-900 font-medium">★★★★★</td><td className="px-4 py-3 text-foreground-700">★★★</td></tr>
                    <tr><td className="px-4 py-3 text-foreground-700">Cena</td><td className="px-4 py-3 text-primary-600 font-medium">Darmowy</td><td className="px-4 py-3 text-secondary-600 font-medium">Darmowy</td></tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Dla kogo jest Superbuy Spreadsheet?
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                <strong>Superbuy Spreadsheet</strong> jest szczególnie polecany dla użytkowników, którzy:
              </p>
              <ul className="space-y-3 list-none pl-0 mb-4">
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-check-line text-secondary-500 text-lg mt-0.5"></i>
                  <span>Szukają uzupełnienia dla <strong>Kakobuy Spreadsheet</strong></span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-check-line text-secondary-500 text-lg mt-0.5"></i>
                  <span>Interesują się głównie sneakersami i odzieżą sportową</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-check-line text-secondary-500 text-lg mt-0.5"></i>
                  <span>Chcą porównać produkty z różnych arkuszy przed zakupem</span>
                </li>
              </ul>
              <p className="text-base text-foreground-700 leading-relaxed">
                Pamiętaj jednak, że <a href="/" className="text-primary-600 hover:text-primary-700 underline">Kakobuy Spreadsheet</a> pozostaje najlepszym wyborem dla większości użytkowników — oferuje najwięcej kategorii, najczęstsze aktualizacje i największą różnorodność produktów.
              </p>
            </section>

            <section className="mt-12 p-8 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-3">
                Sprawdź także inne poradniki
              </h2>
              <div className="flex flex-col sm:flex-row gap-3 justify-center mt-5">
                <a href="/artykul/kakobuy-sheet-kompletny-przewodnik" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300/60 text-foreground-700 text-sm font-semibold hover:bg-background-200 transition-all whitespace-nowrap cursor-pointer">
                  Kakobuy Sheet – Kompletny Przewodnik
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="/artykul/cssbuy-spreadsheet-vs-kakobuy" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300/60 text-foreground-700 text-sm font-semibold hover:bg-background-200 transition-all whitespace-nowrap cursor-pointer">
                  CSSBuy vs Kakobuy
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer">
                  Strona główna
                  <i className="ri-home-line"></i>
                </a>
              </div>
            </section>
          </div>
        </article>
      </main>

      <footer className="w-full bg-background-100 border-t border-background-200/70 py-10 px-4 md:px-8">
        <div className="max-w-[800px] mx-auto text-center">
          <a href="/" className="text-xl font-heading font-bold text-foreground-950 no-underline">
            Kakobuy <span className="text-primary-500">Finds</span>
          </a>
          <p className="text-xs text-foreground-400 mt-3">
            &copy; {new Date().getFullYear()} Kakobuy Finds. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </footer>
    </>
  );
}